export const TAB_OVERVIEW = "overview";

export const TAB_ATTACHMENTS = "attachments";
